(() => {
  document.documentElement.classList.add('hc-c52b-v2');
  const visualSystem = new URLSearchParams(window.location.search).get('hc_system');
  document.documentElement.dataset.hcVisualSystem = ['a', 'b', 'c'].includes(visualSystem) ? visualSystem : 'a';

  const getSearchModals = () => [...document.querySelectorAll('details-modal.header__search')];
  const getDrawer = () => document.querySelector('#Details-menu-drawer-container');
  const getMegaMenus = () => [...document.querySelectorAll('.mega-menu')];

  const closeSearch = () => {
    getSearchModals().forEach((modal) => {
      const details = modal.querySelector('details');
      if (!details?.open) return;
      if (typeof modal.close === 'function') modal.close(false);
      else details.removeAttribute('open');
    });
    document.body.classList.remove('hc-c52b-search-open');
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer?.open) return;
    drawer.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    drawer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
    document.body.classList.remove('hc-c52b-menu-open');
  };

  const closeMegaMenus = (except) => {
    getMegaMenus().forEach((menu) => {
      if (menu !== except) menu.removeAttribute('open');
    });
  };

  const syncDisclosureState = (details) => {
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  };

  document.addEventListener('click', (event) => {
    const searchSummary = event.target.closest('details-modal.header__search summary');
    const drawerSummary = event.target.closest('#Details-menu-drawer-container > summary');
    const megaSummary = event.target.closest('.mega-menu > summary');

    if (searchSummary) {
      closeDrawer();
      closeMegaMenus();
    } else if (drawerSummary) {
      closeSearch();
      closeMegaMenus();
    } else if (megaSummary) {
      closeSearch();
      closeDrawer();
      closeMegaMenus(megaSummary.closest('.mega-menu'));
    }
  }, true);

  const bindDisclosures = () => {
    document.querySelectorAll('details').forEach((details) => {
      if (details.dataset.hcC52bBound === 'true') return;
      details.dataset.hcC52bBound = 'true';
      syncDisclosureState(details);
      details.addEventListener('toggle', () => {
        syncDisclosureState(details);
        if (details.closest('details-modal.header__search')) {
          document.body.classList.toggle('hc-c52b-search-open', details.open);
        }
        if (details.id === 'Details-menu-drawer-container') {
          document.body.classList.toggle('hc-c52b-menu-open', details.open);
        }
      });
    });
  };

  const headerSection = document.querySelector('.shopify-section-header');
  let frame = 0;
  const updateScrolledState = () => {
    frame = 0;
    headerSection?.classList.toggle('hc-c52b-scrolled', window.scrollY > 24);
  };

  window.addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(updateScrolledState);
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMegaMenus();
    document.body.classList.remove('hc-c52b-search-open', 'hc-c52b-menu-open');
  });

  bindDisclosures();
  updateScrolledState();

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', bindDisclosures);
  }
})();
